<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model="searchModel.keyword"
          placeholder="请输入名称或编号"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="state" label="设备状态">
        <el-select v-model="searchModel.state" placeholder="请选择" clearable @change="getTableData(true)">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="state" label="是否即将过期">
        <el-select v-model="searchModel.isExpired" placeholder="请选择" clearable @change="getTableData(true)">
          <el-option label="是" :value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="getTableData(true)">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="cbox-p14 table-main">
      <TableHeader :refTable="refTable" storageKey="hiddenColumns_device" @onRefresh="getTableData()">
        <el-button v-auth="'device:edit'" type="primary" @click="handleAdd">新增</el-button>
        <el-button type="warning" @click="handleExport">导出</el-button>
        <el-button type="success" @click="handlePrint">打印设备标签</el-button>
      </TableHeader>

      <el-table
        ref="table"
        :data="tableData"
        border
        stripe
        :row-class-name="tableRowClassName"
        height="100%"
        v-loading="tableLoading"
      >
        <el-table-column label="序号" align="center" width="50" fixed>
          <template v-slot="{ $index }">
            <span>{{ (searchModel.pageNum - 1) * searchModel.pageSize + $index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="devName" label="设备名称" min-width="180" header-align="center">
          <template v-slot="{ row }">
            <div class="logo-box">
              <el-tooltip effect="dark" :content="`设备有效期：${row.nxCheckTime}`" placement="top">
                <img v-if="row.isTip" src="@/assets/images/device_tip.png" :alt="`设备有效期：${row.nxCheckTime}`" />
              </el-tooltip>
              {{ row.devName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="devCode" label="设备编号" align="center" width="120"></el-table-column>
        <el-table-column prop="mid" label="出厂编号" align="center"></el-table-column>
        <el-table-column prop="producer" label="制造商" align="center"></el-table-column>
        <el-table-column prop="devModel" label="型号规格" align="center" width="120"></el-table-column>
        <el-table-column prop="buyDate" label="购入日期" align="center"></el-table-column>
        <el-table-column prop="assetValue" label="购入金额（元）" align="center"></el-table-column>
        <el-table-column label="设备图片" headeralign="center" min-width="200">
          <template v-slot="{ row }">
            <div class="img-list">
              <el-image
                v-for="(url, imgIndex) in row.imgList"
                :key="imgIndex"
                style="width: 44px; height: 44px"
                :src="url"
                :preview-src-list="row.imgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="使用说明" headeralign="center" min-width="140">
          <template v-slot="{ row }">
            <el-link
              type="primary"
              :underline="true"
              v-for="(file, index) in row.files"
              :key="index"
              :href="`${$imgUrl}${file.filePath}`"
              target="_blank"
            >
              {{ file.fileName }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="state" label="设备状态" align="center">
          <template v-slot="{ row }">
            <el-tag v-if="row.state == -2" type="danger">报废</el-tag>
            <el-tag v-if="row.state == -1" type="danger">停用</el-tag>
            <el-tag v-if="row.state == 1" type="success">合格</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="nxCheckTime" label="设备有效期" align="center" width="100px"></el-table-column>
        <el-table-column prop="accuracy" label="仪器精度" align="center"></el-table-column>
        <el-table-column prop="params" label="技术参数" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="center"></el-table-column>
        <el-table-column label="操作" width="220" align="center" fixed="right">
          <template v-slot="{ row }">
            <el-link type="primary" @click="handleDetail(row)">详情</el-link>
            <el-link v-auth="'device:edit'" type="primary" @click="handleEdit(row)">编辑</el-link>
            <el-link v-auth="'device:delete'" type="danger" @click="handleDelete(row)">删除</el-link>
            <el-link type="warning" @click="handleAdjust(row)">计量校准</el-link>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page="searchModel.pageNum"
        :page-size="searchModel.pageSize"
        background
        layout="total, prev, sizes ,pager, next, jumper"
        :total="dataTotal"
        @current-change="onCurrentChange"
        @size-change="onSizeChange"
      ></el-pagination>
    </div>

    <!-- 新增/编辑 -->
    <DeviceEdit :visible.sync="editVisible" :activeId="activeRowId" @refresh="getTableData()" />
    <!-- 详情 -->
    <DeviceDetail :visible.sync="detailVisible" :activeId="activeRowId" />
    <!-- 打印标签 -->
    <DeviceTag :visible.sync="tagPrintVisible" />
    <!-- 计量校准 -->
    <DeviceAdjust :visible.sync="adjustVisible" :activeInfo="activeRowInfo" />
  </div>
</template>

<script>
import moment from 'moment';
import modal from '@/utils/modal';

import TableHeader from '@/components/TableHeader';
import DeviceTag from './components/DeviceTag';
import DeviceEdit from './components/DeviceEdit';
import DeviceDetail from './components/DeviceDetail';
import DeviceAdjust from './components/DeviceAdjust';

import { getDictsByCode } from '@/api/system';
import { getDeviceList, deleteDeviceById } from '@/api/device';

export default {
  name: 'Home',
  components: { TableHeader, DeviceEdit, DeviceDetail, DeviceTag, DeviceAdjust },
  data() {
    return {
      refTable: null,
      searchModel: {
        pageNum: 1,
        pageSize: 20,
        devType: '',
        keyword: '',
        state: '',
        isExpired: '',
        dateRange: []
      },
      devTypeOptions: [],
      statusOptions: [
        {
          label: '合格',
          value: 1
        },
        {
          label: '停用',
          value: -1
        },
        {
          label: '报废',
          value: -2
        }
      ],
      dataTotal: 0,
      tableLoading: false,
      tableData: [],
      // 弹窗
      activeRowId: null,
      activeRowInfo: {},
      detailVisible: false,
      editVisible: false,
      tagPrintVisible: false,
      adjustVisible: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.getTableData();
    },
    onCurrentChange(pageNum) {
      this.searchModel.pageNum = pageNum;
      this.getTableData();
    },
    onSizeChange(pageSize) {
      this.searchModel.pageNum = 1;
      this.searchModel.pageSize = pageSize;
      this.getTableData(true);
    },
    async getTableData(isFirstPage = false) {
      if (isFirstPage) this.searchModel.pageNum = 1;
      this.tableLoading = true;

      const { data } = await getDeviceList(this.searchModel);
      this.dataTotal = data.count;
      const tableData = data.list || [];
      tableData.forEach(item => {
        let isTip = false;
        if (item.state == 1 && item.nxCheckTime) {
          // 30天过期提醒
          const diffDays = moment().diff(moment(item.nxCheckTime), 'days') + 1;
          if (diffDays > -31) isTip = true;
        }
        if (item.fileName) {
          item.imgList = item.fileName.split(',').map(item => {
            return this.$imgUrl + item;
          });
        }
        if (item.filePath) {
          item.files = JSON.parse(item.filePath);
        }
        return {
          ...item,
          isTip
        };
      });

      this.tableData = tableData;
      this.tableLoading = false;
    },
    // 详情
    handleDetail(row) {
      this.activeRowId = row.id;
      this.detailVisible = true;
    },
    handleAdd() {
      this.activeRowId = null;
      this.editVisible = true;
    },
    handleEdit(row) {
      this.activeRowId = row.id;
      this.editVisible = true;
    },
    tableRowClassName({ row }) {
      if (row.isTip) {
        return 'warning-row';
      }
    },
    async handleExport() {
      modal.loading('数据导出中...');
      const { export_json_to_excel } = require('@/excel/Export2Excel.js'); //这里必须使用绝对路径，使用@/+存放export2Excel的路径

      const { data } = await getDeviceList({ ...this.searchModel, pageSize: 99999 });
      const exportTableData = data.list || [];
      exportTableData.map((item, index) => {
        item.tableNo = index + 1;
        item.state = item.state == 1 ? '合格' : item.state == -1 ? '停用' : '报废';
      });

      const time = moment().format('YYYY_MM_DD');
      const filename = `仪器设备清单-系统导出${time}`;
      const tHeader = ['序号'];
      const filterVal = ['tableNo'];
      const excelColmn1 = ['仪器设备清单-系统导出'];

      const columns = this.$refs.table.columns;
      columns.forEach(column => {
        if (column.label == '序号' || column.label == '操作') return;
        tHeader.push(column.label);
        filterVal.push(column.property);
        excelColmn1.push('');
      });

      const multiHeader = [excelColmn1]; // 标题

      const formatData = this.formatJson(filterVal, exportTableData);

      const merges = this.getMerges(excelColmn1.length); //需要合并的单元格

      export_json_to_excel(tHeader, formatData, filename, multiHeader, merges);
      modal.closeLoading();
    },
    getMerges(mergesLen) {
      let merges = '';
      for (let i = 0; i < mergesLen; i++) {
        const str = String.fromCharCode(65 + i) + '1:';
        merges += str;
      }

      return [merges.slice(0, -1)];
    },
    /**
     * 格式转换
     * @param filterVal
     * @param jsonData
     * @returns {*}
     */
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleDelete(row) {
      this.$confirm('确定删除所选信息吗？删除后将无法恢复。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          await deleteDeviceById({ id: row.id });
          this.$message.success('删除成功');
          this.getTableData();
        })
        .catch(() => {});
    },
    handlePrint() {
      this.tagPrintVisible = true;
    },
    handleAdjust(row) {
      this.activeRowInfo = row;
      console.log('this.activeRowInfo 打印:', this.activeRowInfo);
      this.adjustVisible = true;
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    }
  },
  mounted() {
    this.refTable = this.$refs.table;
    this.getDictsByCode('device_type', 'devTypeOptions');
  },
  activated() {
    this.getTableData();
    this.$nextTick(() => {
      this.$refs.table.doLayout(); // 重置表格布局
    });
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  .warning-row {
    .el-table__cell {
      position: relative;
    }
  }
  .logo-box {
    padding-left: 12px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 24px;
      height: 24px;
    }
  }
}

.img-list {
  display: flex;
  flex-wrap: wrap;
  .el-image {
    margin: 0 10px 10px 0;
    background-color: #fbfdff;
    border: 1px dashed #c0ccda;
    border-radius: 6px;
  }
}
</style>
